import { useEffect } from "react";
import { Accordion } from "react-bootstrap";

interface AccordionItem {
  id: string; // or number, based on your actual data
  heading: string;
  items: string[];
}

interface Props {
  jsonData?: AccordionItem[];
}

const ServicesAccordion: React.FC<Props> = ({ jsonData }) => {
  useEffect(() => {
    import("./services.css");
  }, []);
  return (
    <div className="col-md-6 wow animate__zoomIn">
      <Accordion className="p-4 rounded bg-white">
        {jsonData?.map((data, index) => (
          <Accordion.Item eventKey={data.id} key={index}>
            <Accordion.Header
              id={`heading${index}`}
              data-bs-target={`#${data.id}`}
              data-bs-toggle="collapse"
              aria-expanded="true"
              aria-controls={data.id}
              // className="accordion-button"
              style={{ fontWeight: "bolder" }}
            >
              {data.heading}
            </Accordion.Header>
            <Accordion.Body>
              <ul className="d-flex flex-wrap">
                {data.items.map((item, itemIndex) => (
                  <li className="col-12 col-md-6" key={itemIndex}>
                    <a className="text-decoration-none text primary">
                      {" "}
                      {item}{" "}
                    </a>
                  </li>
                ))}
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  );
};

export default ServicesAccordion;
